<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #SHOWSTATUS>
      <order-tracker v-if="statusId" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getList } from "@/api/analysis/tt_track";
import { getCountry } from "@/api/system/country";
import { getSelectType, getDuration } from "@/api/public";
import { getUser } from "@/api/user/internal";
import { getChannel } from "@/api/tracker/channel";
import { getAgent } from "@/api/tracker/agent";
import { getStatus } from "@/api/tracker/status";
import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/order_tracker";
import cTable from "@/base/common/index";
// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "tt_track",
  components: {
    cTable,
    orderTracker
  },
  props: {
    tm: {
      type: Boolean,
      default: false
    },
    apis: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    this.config.tm = this.tm;
  },
  methods: {
    isShow() {
      return this.$route.name != "delayShipments";
    }
  },
  data() {
    return {
      statusId: "",
      methods: {
        list: getList,
        getCountry,
        getAgent,
        getAllClient,
        getChannel,
        getSelectType
      },
      config: {
        tm: this.tm,
        height: 630,
        isGetList: true
      },
      modals: {
        showstatus: {
          contentSlot: "SHOWSTATUS",
          methods: {
            cancel: ({ close }) => {
              this.statusId = "";
            }
          },
          footer: {
            show: false
          }
        }
      },
      header: {
        searchs: [
          {
            key: "start_time",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            }
          },
          {
            key: "end_time",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              "model-value": Date(),
              style: {
                width: "175px"
              }
            }
          },
          {
            key: "duration_time",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("Duration Time");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:140px"
            }
          },
          {
            key: "tracker_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("tracker_code");
            },
            clearable: true,
            options: [],
            config: { label: "tracker_code", value: "tracker_code" },
            bind: {
              style: "width:140px"
            }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("Push Status");
            },
            clearable: true,
            options: [
              { value: 0, label: this.$t("Synchronizing") },
              { value: 1, label: this.$t("success") },
              { value: 2, label: this.$t("error") },
              { value: 3, label: this.$t("Manual Intervention") }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                console.log(this.config);
                return !this.config.tm && !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export({ searchForm }) {
              if (this.config.tm) {
                this.handleRequestMethods(
                  "list",
                  { ...searchForm, export: 1 },
                  false,
                  true
                ).then(res => {
                  this.$Message.success(res.msg);
                });
              } else {
                this.exportExc();
              }
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        // {
        // 	name:()=>this.$t("Tracker ID"),
        // 	key:"id",
        // 	minWidth:130,
        // },
        {
          name: () => this.$t("Tracking number"),
          key: "awbno",
          minWidth: 130
        },
        {
          name: () => this.$t("Tracker Status"),
          key: "status",
          width: 100
        },
        {
          name: () => this.$t("Push duration"),
          key: "duration_time",
          width: 100
        },
        {
          name: () => this.$t("Occurred Time"),
          key: "create_time",
          minWidth: 150
        },
        {
          name: () => this.$t("Input Time"),
          key: "update_time",
          minWidth: 150
        },
        {
          name: () => this.$t("input channel"),
          key: "flag",
          minWidth: 130
        },
        {
          name: () => this.$t("Push Error Count"),
          key: "error_count",
          width: 100
        },
        {
          name: () => this.$t("Start Push Time"),
          key: "send_time",
          minWidth: 150
        },
        {
          name: () => this.$t("Push Status Time"),
          key: "last_time",
          minWidth: 150
        },
        {
          name: () => this.$t("Push Status"),
          key: "send_status",
          minWidth: 130
        }
      ]
    };
  },
  mounted() {
    Object.assign(this.methods, this.apis);
    this.$refs["table"].getList();
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "duration_time")
        item.options = (await getDuration()).data.payload;
      if (item.key === "to_country")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "deliver")
        item.options = (
          await getAgent({
            agent_type: "bag",
            status: "YES",
            types: "DELIVERY"
          })
        ).data.payload.rows;
      if (item.key === "frequency")
        item.options = (
          await getSelectType(["TIME_OUT_NOT_DELIVERY"])
        ).data.payload["TIME_OUT_NOT_DELIVERY"];
      if (item.key === "tracker_status")
        item.options = (await getStatus({ pageSize: 9999 })).data.payload.rows;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
    });
  }
};
</script>
